import { Button, styled } from '@mui/material';

// Matches SegmentedFilter: the selected option is a raised white pill on a grey track. Its
// border carries the state at 3:1, which the pill and shadow alone do not (WCAG 1.4.11).
export const ButtonToggle = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'view',
})<{ view: boolean; value: string }>(({ theme, view }) => ({
  display: 'flex',
  minWidth: 0,
  padding: 2,
  border: `1px solid ${view ? theme.palette.text.secondary : 'transparent'}`,
  borderRadius: theme.spacing(0.5),
  color: view ? theme.palette.primary.dark : theme.palette.text.secondary,
  backgroundColor: view ? theme.palette.common.white : 'transparent',
  boxShadow: view ? theme.shadows[1] : 'none',
  '&:hover': {
    color: theme.palette.primary.dark,
    backgroundColor: view ? theme.palette.common.white : theme.palette.action.hover,
    boxShadow: view ? theme.shadows[1] : 'none',
  },
  '& svg': {
    fontSize: 20,
  },
}));
